<ion-content fullscreen>
  <div id="wrapper" class="ion-padding">
    <div id="id">
      <ion-fab-button color="light" size="small" (click)="goNotifications()">
        <ion-icon src="/assets/icon/notifications-new.svg" *ngIf="!isEveryNotificationRead"></ion-icon>
        <ion-icon src="/assets/icon/notifications.svg" *ngIf="isEveryNotificationRead"></ion-icon>
      </ion-fab-button>
      <ion-fab-button color="light" size="small" (click)="goId()">
        <ion-icon src="/assets/icon/id.svg" class="icon_id"></ion-icon>
      </ion-fab-button>
    </div>
    <ion-icon src="/assets/icon/tecservice.svg" class="header-logo"></ion-icon>

    <ion-item>
      <ion-avatar slot="start" (click)="goId()">
        <img [src]="user.avatar" *ngIf="user && user.avatar" />
        <img src="/assets/imgs/logo-blanco.png" *ngIf="!user || !user.avatar" />
      </ion-avatar>
      <ion-label>
        {{ user?.name }} {{user?.lastname}}
        <span>{{user?.enrollment}}</span>
      </ion-label>
    </ion-item>
    <div class="slider-wrapper">
      <swiper-container #swiper [pagination]="true" *ngIf="ads" id="ads">
        <swiper-slide *ngFor="let ad of ads; let i = index;">
          <ion-img [src]="ad.image" (click)="openAd(ad)"></ion-img>
        </swiper-slide>
      </swiper-container>
    </div>

    <ion-card color="light">
      <ion-card-content>
        <p>Mi balance</p>
        <h1>{{balance | currency }}</h1>
        <hr />
        <div class="button-container">
          <div *ngIf="vendorsStore.isVendorsAvailable()">
            <ion-fab-button color="light" (click)="addBalance()">
              <ion-icon src="/assets/icon/add-balance-icon.svg"></ion-icon>
            </ion-fab-button>
            <ion-label>Recargar saldo</ion-label>
          </div>
          <div *ngIf="vendorsStore.vendorsQuery.isLoading()">
            <ion-spinner name="crescent" class="ion-margin-top"></ion-spinner>
          </div>
        </div>
        <div class="button-container" (click)="transactionsList()">
          <ion-fab-button color="light">
            <ion-icon src="/assets/icon/transactions-icon.svg"></ion-icon>
          </ion-fab-button>
          <ion-label>Transacciones</ion-label>
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
